import React from 'react';
import { useTranslation } from 'react-i18next';
import { GoalHierarchyItem as GoalHierarchyItemType } from './types';
import { GoalHierarchyItem } from './GoalHierarchyItem';
import { mapGoalHierarchyToFlatArray } from './mappings';
import Skeleton from 'react-loading-skeleton';

type Props = {
  rootGoal: GoalHierarchyItemType;
  currentGoalId: string;
  onLinkClick?: () => void;
};

export const GoalHierarchy: React.FC<Props> = ({
  rootGoal,
  currentGoalId,
  onLinkClick,
}) => {
  const { t } = useTranslation();
  const goalsToRender = mapGoalHierarchyToFlatArray(rootGoal);
  // do not render for standalone goal
  if (goalsToRender.length < 2) {
    return null;
  }

  return (
    <div className="p-3 rounded border goal-hierarchy">
      <h3 className="mb-2">
        {t('performanceReview.goals2.goalSidebar.hierarchyStructure')}
      </h3>
      <div className="d-flex flex-column">
        {goalsToRender.map((goal) => (
          <GoalHierarchyItem
            key={goal.id}
            goal={goal}
            currentGoalId={currentGoalId}
            onLinkClick={onLinkClick}
          />
        ))}
      </div>
    </div>
  );
};

export const GoalHierarchyLoading: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="p-3 rounded border goal-hierarchy">
      <h3 className="mb-2">
        {t('performanceReview.goals2.goalSidebar.hierarchyStructure')}
      </h3>
      <div className="d-flex flex-column gap-2">
        <Skeleton width="26rem" height="1rem" />
        <Skeleton width="25rem" height="1rem" style={{ marginLeft: '1rem' }} />
        <Skeleton width="25rem" height="1rem" style={{ marginLeft: '1rem' }} />
        <Skeleton width="24rem" height="1rem" style={{ marginLeft: '2rem' }} />
        <Skeleton width="24rem" height="1rem" style={{ marginLeft: '2rem' }} />
        <Skeleton width="26rem" height="1rem" />
      </div>
    </div>
  );
};
